<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";

/**
 * Login component
 */
export default {
   page: {
      title: "Login",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
   },
   data() {
      return {
         errors: {},
         email: '',
         password: '',   
         token: '',
         countries:[],
         show_password: false,

      };
   },
  
   methods: {


      onSubmit() {

         let data;

        data = JSON.stringify({
            "username": this.email,
            "password": this.password
        });


         //console.log(data);
         const config = {
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
         };

         this.errors = {};
         this.$axios
            .post("counter/login/counter", data, config)
            .then((response) => {
               var responseData = response.data.data;
               console.log(responseData);
               if (responseData.token) {
                  localStorage.setItem('medicino_counter', JSON.stringify(responseData));
                  
                  this.token = responseData.token;

                  if (Number(responseData.token_management_type) === 3) {
                     this.$router.push({ name: 'outsource-tokens' });
                     this.$swal("", response.data.message, "success");
                  } else if (responseData.token_management_type == null) {
                     this.resolveTokenRouteAfterLogin(responseData, response.data.message);
                  } else {
                     this.$router.push({ name: 'tokens' });
                     this.$swal("", response.data.message, "success");
                  }        
               
            } else {
               this.$swal("", "Failed to fetch token, please try again", "error");
            }
         })
         .catch((error) => {
            if (error.response && error.response.data) {
                this.errors = error.response.data.message;
                this.$swal("", this.errors, "error");
            } else {
                this.errorMessage = error.message;
                this.$swal("", "Something went wrong", "error");
            }
        });
      },

      // fetchSettings() {
      //       let url = "api/admin/settings/index";         
      //       //this.getToken();
      //       this.loading = true;
      //       this.$axios
      //       .get(url, { headers: { Authorization: "Bearer " + this.token } })
      //       .then((res) => {
      //          var responseData = res.data.data;
      //          console.log(responseData);
      //          var admin = responseData.admins[0];
      //          admin.token = this.token;
      //          localStorage.setItem('medicino_counter', JSON.stringify(admin));

      //          this.$router.push({ name: "dashboard" });
      //          this.$swal("", "You have logged in successfully", "success");         
      //       })
      //       .catch((error) => {
      //             if (error.response) {
      //                if (error.response.data.message) {
      //                   if(typeof error.response.data.message === 'object') {
      //                      console.log(error.response.status);
      //                   } else {
      //                      this.$swal("", error.response.data.message, "error");
      //                   }                        
                        
      //                } else {
      //                   this.$swal("", "Something went wrong", "error");
      //                }
      //             } else {
      //                this.$swal("", "Something went wrong", "error");
      //             }
      //       })
      //       .finally(() => (this.loading = false));
      //    },
         togglePassword() {
            if(this.show_password == false) {
               this.show_password = true;
            } else {
               this.show_password = false;
            }
         },

         resolveTokenRouteAfterLogin(responseData, message) {
            this.$axios
               .get('counter/outsource/tokens', {
                  headers: { Authorization: 'Bearer ' + responseData.token },
               })
               .then((res) => {
                  if (Number(res.data?.data?.token_management_type) === 3) {
                     responseData.token_management_type = 3;
                     localStorage.setItem('medicino_counter', JSON.stringify(responseData));
                     this.$router.push({ name: 'outsource-tokens' });
                  } else {
                     this.$router.push({ name: 'tokens' });
                  }
                  this.$swal('', message, 'success');
               })
               .catch(() => {
                  this.$router.push({ name: 'tokens' });
                  this.$swal('', message, 'success');
               });
         },
   },
};

</script>

<template>
   <Layout>
      <div class="row justify-content-center">
         <div class="col-md-8 col-lg-6 col-xl-5">
            <div class="card overflow-hidden">
               <div class="bg-soft bg-primary">
                  <div class="row">
                     <div class="col-7">
                        <div class="text-primary p-4">
                           <h5 class="text-primary">Welcome Back !</h5>
                           <p>Sign in to continue MEDICINO COUNTER</p>
                        </div>
                     </div>
                     <div class="col-5 align-self-end">
                        <img src="@/assets/images/profile-img.png" alt class="img-fluid"/>
                     </div>
                  </div>
               </div>
               <div class="card-body pt-0">
                  <div>
                     <router-link tag="a" to="/">
                        <div class="avatar-md profile-user-wid mb-4">
                           <span class="avatar-title rounded-circle bg-light">
                              <img src="@/assets/images/logo.png" alt height="90" />
                           </span>
                        </div>
                     </router-link>
                      <div class="d-flex justify-content-center mb-4">
                        <div class="highlight-box">
                           <span class="highlight-text">MEDICINO COUNTER</span>
                        </div>
                     </div>  
                  </div>   
                   

                  <b-form class="p-2" @submit.prevent="onSubmit">
            
                     <!-- <b-form-group class="mb-3" id="input-group-1" label="Username" label-for="input-1">
                        <b-form-input id="input-1" v-model="email" type="text" placeholder="Enter email" :class="{ 'is-invalid': Boolean(errors.username)  }"></b-form-input>
                
                        <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                        </div> 
                     </b-form-group> -->
                     

                     <b-form-group class="mb-3" id="input-group-1" label="Email" label-for="input-1">
                           <b-form-input id="input-1" v-model="email" type="text" placeholder="Enter email" :class="{ 'is-invalid': Boolean(errors.username)  }"></b-form-input>

                           <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>   
                  
                        </b-form-group>
                        

                        <!-- <b-form-group class="mb-3" id="input-group-2" label="Password" label-for="input-2">
                           <b-form-input id="input-2" v-model="password" type="password" placeholder="Enter password" :class="{ 'is-invalid': Boolean(errors.password)  }"></b-form-input>

                           <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>   
                        </b-form-group> -->
                        <b-col md="12" class="form-group">
                        <label class="control-label">Password</label>
                        <b-input-group>
                              <b-form-input type="password" v-model="password" placeholder="Enter password"  v-if="!show_password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-form-input type="text" v-model="password" placeholder="Enter password" v-else v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>
                              <b-input-group-text @click="togglePassword()">
                                 <i class="fas fa-eye" v-if="show_password"></i>
                                 <i class="fas fa-eye-slash" v-else></i>
                              </b-input-group-text>
                               
                               
                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-input-group>
                        </b-col>
                        <div class="mt-3 d-grid">
                           <b-button type="submit" variant="primary" class="btn-block">Log In</b-button>
                        </div>
                     </b-form>
               </div>
               <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="mt-5 text-center">
          
               <p>
                  © {{ new Date().getFullYear() }} MEDICINO.
                  <!-- © {{ new Date().getFullYear() }} MEDICINO. Powered by Sigosoft -->
               </p>
            </div>
            <!-- end row -->
         </div>
         <!-- end col -->
      </div>
      <!-- end row -->
   </Layout>
</template>

<style>
.highlight-box {
   background-color: #f0f8ff; 
   padding: 4px 8px; 
   border-radius: 3px; 
   border: 1px solid #004080; 
   display: inline-block; 
   margin-top: -25px;
}

.highlight-text {
   color: #004080; 
   font-size: 0.875rem;
   font-weight: 500; 
}
</style>